export default "__VITE_ASSET__DBarwDy___"